import React from 'react'

export default function FolderIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3598 9.93787H10.8388L9.81387 8.91299C9.58746 8.68698 9.28733 8.5625 8.96786 8.5625H5.64023C4.59802 8.56331 3.75 9.41173 3.75 10.4535V18.3605C3.75 19.4031 4.59802 20.2507 5.64023 20.2507H18.359C19.402 20.2507 20.25 19.4031 20.25 18.3605V11.8293C20.25 10.7863 19.402 9.93787 18.3598 9.93787Z" fill="currentColor"/>
            <path d="M8.96806 7.407C9.59613 7.407 10.1863 7.65194 10.6307 8.09589L11.3176 8.78237H18.188V5.63959C18.188 4.59699 17.3402 3.74927 16.2976 3.74927H7.70388C6.66022 3.74927 5.8125 4.59699 5.8125 5.63959V7.407H8.96806Z" fill="currentColor"/>
        </svg>
    )
}
